import { appOptions } from "./appOptions";
import { OpenAPI } from "./MksapAPI";
import { getRequestAuthHeaders } from "./utils/getAjaxRequestOptions";
import { possiblyInterceptRequestForDebugging } from "./utils/makeAjaxPromise";

OpenAPI.BASE = appOptions.ajaxPrefix;
OpenAPI.HEADERS = async (requestOptions) => {
	await possiblyInterceptRequestForDebugging({
		url: requestOptions.url,
		method: requestOptions.method,
	});
	return Promise.resolve(getRequestAuthHeaders());
};
